module.exports = __webpack_public_path__ + "img/0024_bluejean.78513a8f.jpg";